// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tYCfZYrYfE0fD8tVPqSQ{width:100%;max-height:278px;overflow-y:auto}.KUKeSpPcBw1av2WaIL1k{width:100%;padding:0 16px 20px}.KUKeSpPcBw1av2WaIL1k.L6SiZhMRyH0NSbLyvxIJ{padding:24px 16px}.ovxkylNvZEBnmreFnmkZ{width:100%}.yXhcHW7XRokqdhjOvyUs{background-color:var(--border-neutral-default);width:100%;height:1px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tYCfZYrYfE0fD8tVPqSQ`,
	"tabContent": `KUKeSpPcBw1av2WaIL1k`,
	"note": `L6SiZhMRyH0NSbLyvxIJ`,
	"tabs": `ovxkylNvZEBnmreFnmkZ`,
	"divider": `yXhcHW7XRokqdhjOvyUs`
};
export default ___CSS_LOADER_EXPORT___;
